export const isStaging = () => {
    return process.env.REACT_APP_INS_ENV.toLowerCase() === 'staging'
}

export const getMSLURL = () => {
    return isClubLeaDomain() ? `https://auth.clublea.pro` : `https://my${isStaging() ? '-dev' : ''}.synkd.life`
}
/**
 * Browser-only check based on window.location.hostname.
 * Returns true when current hostname is clublea.pro (includes subdomains).
 */
export const isClubLeaDomain = () => {
  try {
    if (typeof window === 'undefined' || !window.location) return false;
    const hostname = (window.location.hostname || '').toLowerCase().replace(/\.$/, '');
    if (!hostname) return false;
    return hostname !== 'synkd.life' && !hostname.endsWith('.synkd.life');
  } catch (e) {
    return false;
  }
}
